import { QueryClient } from "react-query";

export class QueryClientManager {
    private static instance: QueryClient;

    public static initialize(queryClient: QueryClient) {
        QueryClientManager.instance = queryClient;
    }

    public static getInstance(): QueryClient {
        if (!QueryClientManager.instance) {
            throw new Error("QueryClientManager has not been initialized. Make sure to call initialize() first.");
        }
        return QueryClientManager.instance;
    }
}